module.exports = __webpack_public_path__ + "b47d4c88e9911621b9f24eebeb0cd425.pdf";